module.exports = __webpack_public_path__ + "static/21-09-28_11-49-47_ACB1-5c3d6624cde2876eb71f4d67e6cf34a5.jpg";